import { createContext } from 'react'
import { AppAbility } from '../acl/acl'

export const AbilityContext = createContext(AppAbility)
